// import i18n from '@/i18n/index'

export default {
  basicInformation: [{
    prop: 'date'
  }, {
    prop: 'cost_price'
  }, {
    prop: 'price'
  }, {
    prop: 'updated_at'
  }, {
    prop: 'created_at'
  }]
}
